export function normalizeSingleLineText(value: unknown): string {
  return String(value ?? '').replace(/\s+/g, ' ').trim();
}
